import { BookmarkData } from '../types';

export const bookmarks: BookmarkData = {
  "ALL": [
    {
      "name": "Demand List | AI Navigation | theresanaiforthat",
      "url": "https://theresanaiforthat.com/requests",
      "description": "Discover the latest AI tools and product demands",
      "tags": ["AI", "Demand", "Navigation", "Tools", "Products", "Discovery", "Latest", "Trends", "Market", "Research"],
      "icon": "🔍"
    },
    {
      "name": "Rankings | AI Navigation | Toolify",
      "url": "https://www.toolify.ai/Best-AI-Tools-revenue",
      "description": "Top AI tools ranked by revenue",
      "tags": ["AI", "Rankings", "Revenue", "Ranking", "Tools", "Navigation", "Popular", "Trends", "Market", "Analysis"],
      "icon": "📊"
    },
    {
      "name": "Keywords | Expansion | Google Suggestions",
      "url": "https://www.searchsuggest.tips/?keyword=",
      "description": "Get Google search suggestion keywords",
      "tags": ["Keywords", "SEO", "Search", "Google", "Expansion", "Suggestions", "Optimization", "Research", "Market", "Analysis"],
      "icon": "🔑"
    },
    {
      "name": "Keywords | Competition Difficulty",
      "url": "https://ahrefs.com/keyword-difficulty",
      "description": "Analyze keyword competition difficulty",
      "tags": ["Keywords", "SEO", "Competition", "Difficulty", "Analysis", "Research", "Market", "Optimization", "Strategy", "Tools"],
      "icon": "📈"
    },
    {
      "name": "Domain | Search",
      "url": "https://leandomainsearch.com/",
      "description": "Find available domains",
      "tags": ["Domain", "Search", "Registration", "Website", "Availability", "Search", "Tools", "Discovery", "Brand", "Name"],
      "icon": "🌐"
    },
    {
      "name": "Domain | Registration",
      "url": "spaceship.com",
      "description": "Register and manage domains",
      "tags": ["Domain", "Registration", "Management", "Website", "Service", "Hosting", "Brand", "Name", "Tools", "Platform"],
      "icon": "🚀"
    },
    {
      "name": "Website Code | Hosting",
      "url": "https://github.com/WebStackPage/WebStackPage.github.io",
      "description": "Website code hosting and version control",
      "tags": ["Code", "Hosting", "GitHub", "Version Control", "Website", "Development", "Collaboration", "Open Source", "Management", "Tools"],
      "icon": "💻"
    },
    {
      "name": "GSC",
      "url": "https://search.google.com/search-console",
      "description": "Google Search Console, monitor website search performance",
      "tags": ["SEO", "Google", "Search", "Console", "Monitoring", "Analysis", "Performance", "Optimization", "Data", "Tools"],
      "icon": "🔍"
    },
    {
      "name": "GA",
      "url": "https://analytics.google.com/analytics/web/#",
      "description": "Google Analytics, website traffic analysis tool",
      "tags": ["Analytics", "Traffic", "Google", "Data", "Statistics", "Monitoring", "Performance", "Users", "Behavior", "Tools"],
      "icon": "📊"
    },
    {
      "name": "Backlinks",
      "url": "https://ahrefs.com/free-seo-tools",
      "description": "Analyze website backlinks and SEO performance",
      "tags": ["SEO", "Backlinks", "Analysis", "Tools", "Optimization", "Research", "Data", "Monitoring", "Performance", "Strategy"],
      "icon": "🔗"
    },
    {
      "name": "Traffic, Website Keywords",
      "url": "aitdk.com",
      "description": "Analyze website traffic and keywords",
      "tags": ["Traffic", "Keywords", "Analysis", "SEO", "Data", "Research", "Optimization", "Monitoring", "Performance", "Tools"],
      "icon": "📈"
    },
    {
      "name": "Website Keywords",
      "url": "semrush.com",
      "description": "Comprehensive SEO and keyword analysis tool",
      "tags": ["SEO", "Keywords", "Analysis", "Tools", "Optimization", "Research", "Data", "Monitoring", "Performance", "Strategy"],
      "icon": "🔍"
    },
    {
      "name": "Vercel Website Templates",
      "url": "https://vercel.com/templates",
      "description": "Quickly deployable website templates",
      "tags": ["Templates", "Website", "Deployment", "Vercel", "Development", "Frontend", "Quick", "Responsive", "Design", "Tools"],
      "icon": "🚀"
    },
    {
      "name": "Browser Extension Product | Website Template",
      "url": "https://github.com/mundane799699/xlike-web",
      "description": "Browser extension product website template",
      "tags": ["Extension", "Browser", "Template", "Website", "Development", "Frontend", "Product", "Design", "Tools", "GitHub"],
      "icon": "🔌"
    },
    {
      "name": "SaaS Product | Website Template",
      "url": "https://github.com/JavascriptMick/supanuxt-saas",
      "description": "SaaS product website template",
      "tags": ["SaaS", "Template", "Website", "Development", "Frontend", "Product", "Design", "Tools", "GitHub", "Quick"],
      "icon": "💼"
    },
    {
      "name": "SaaS Product | App Template",
      "url": "https://github.com/wasp-lang/open-saas/",
      "description": "SaaS application template",
      "tags": ["SaaS", "Application", "Template", "Development", "Frontend", "Product", "Design", "Tools", "GitHub", "Quick"],
      "icon": "📱"
    },
    {
      "name": "Green Screen Video | Website Template",
      "url": "https://github.com/replicate/green-screen-creator",
      "description": "Green screen video production website template",
      "tags": ["Video", "Green Screen", "Template", "Website", "Development", "Frontend", "Product", "Design", "Tools", "GitHub"],
      "icon": "🎬"
    },
    {
      "name": "AI Product | Website Template",
      "url": "https://github.com/Pwntus/change-hairstyle-ai",
      "description": "AI hairstyle change product website template",
      "tags": ["AI", "Hairstyle", "Template", "Website", "Development", "Frontend", "Product", "Design", "Tools", "GitHub"],
      "icon": "🤖"
    },
    {
      "name": "Viggle AI Web UI",
      "url": "https://github.com/ai-aigc-studio/Viggle-AI-WebUI",
      "description": "Viggle AI web interface",
      "tags": ["AI", "Web UI", "Interface", "Development", "Frontend", "Product", "Design", "Tools", "GitHub", "Quick"],
      "icon": "🎨"
    },
    {
      "name": "VPS | Website Template",
      "url": "https://github.com/ashleyrudland/nextjs_vps",
      "description": "VPS service website template",
      "tags": ["VPS", "Template", "Website", "Development", "Frontend", "Product", "Design", "Tools", "GitHub", "Quick"],
      "icon": "🖥️"
    },
    {
      "name": "Excel-like Product | Website Template",
      "url": "https://github.com/weijunext/smart-excel-ai",
      "description": "Smart Excel product website template",
      "tags": ["Excel", "AI", "Template", "Website", "Development", "Frontend", "Product", "Design", "Tools", "GitHub"],
      "icon": "📊"
    },
    {
      "name": "Overseas Community New Project Mining | Website Template",
      "url": "https://github.com/daimajia/huntscreens",
      "description": "Overseas community new project mining website template",
      "tags": ["Community", "Project", "Template", "Website", "Development", "Frontend", "Product", "Design", "Tools", "GitHub"],
      "icon": "🔍"
    },
    {
      "name": "Weekly|Blog|Portfolio|Boilerplate | Website Template",
      "url": "https://github.com/weijunext/new-blog",
      "description": "Blog and portfolio website template",
      "tags": ["Blog", "Portfolio", "Template", "Website", "Development", "Frontend", "Product", "Design", "Tools", "GitHub"],
      "icon": "📝"
    },
    {
      "name": "Landing Page | Website Template",
      "url": "https://github.com/weijunext/landing-page-boilerplate",
      "description": "Landing page website template",
      "tags": ["Landing Page", "Template", "Website", "Development", "Frontend", "Product", "Design", "Tools", "GitHub", "Quick"],
      "icon": "🏠"
    },
    {
      "name": "Navigation Site | Website Template",
      "url": "https://github.com/fre123-com/fre123-nav/",
      "description": "Navigation site website template",
      "tags": ["Navigation", "Template", "Website", "Development", "Frontend", "Product", "Design", "Tools", "GitHub", "Quick"],
      "icon": "🧭"
    },
    {
      "name": "Reddit Subreddits",
      "url": "https://liberating-doll-b8a.notion.site/Reddit-1a8e8aed91b18021839ecba8b74e530b",
      "description": "Collection of Reddit-related subreddits",
      "tags": ["Reddit", "Community", "Social", "Discovery", "Communication", "Sharing", "Discussion", "Information", "Resources", "Tools"],
      "icon": "💬"
    },
    {
      "name": "Google Search Center | SEO Basics",
      "url": "https://developers.google.com/search/docs/fundamentals/creating-helpful-content?hl=zh-cn",
      "description": "Google SEO basics guide",
      "tags": ["SEO", "Google", "Search", "Basics", "Knowledge", "Guide", "Optimization", "Content", "Strategy", "Tools"],
      "icon": "📚"
    },
    {
      "name": "Top trending websites | Ahrefs",
      "url": "https://ahrefs.com/websites#trending",
      "description": "Popular trending website analysis",
      "tags": ["Trends", "Websites", "Analysis", "Popular", "Data", "Research", "Monitoring", "Performance", "Strategy", "Tools"],
      "icon": "🔥"
    },
    {
      "name": "Projects with $500 Monthly Revenue (Source: HN)",
      "url": "https://www.500mrr.com/",
      "description": "Collection of projects with $500 monthly revenue",
      "tags": ["Revenue", "Projects", "Entrepreneurship", "Income", "Business", "Model", "Case Studies", "Research", "Strategy", "Tools"],
      "icon": "💰"
    },
    {
      "name": "YCombinator",
      "url": "https://news.ycombinator.com/item?id=42373343",
      "description": "YCombinator startup community",
      "tags": ["Startup", "Community", "YCombinator", "Investment", "Accelerator", "Projects", "Case Studies", "Research", "Strategy", "Tools"],
      "icon": "🚀"
    }
  ],
  "keywords": [
    {
      "name": "Demand List | AI Navigation | theresanaiforthat",
      "url": "https://theresanaiforthat.com/requests",
      "description": "Discover the latest AI tools and product demands",
      "tags": ["AI", "Demand", "Navigation", "Tools", "Products", "Discovery", "Latest", "Trends", "Market", "Research"],
      "icon": "🔍"
    },
    {
      "name": "Rankings | AI Navigation | Toolify",
      "url": "https://www.toolify.ai/Best-AI-Tools-revenue",
      "description": "Top AI tools ranked by revenue",
      "tags": ["AI", "Rankings", "Revenue", "Ranking", "Tools", "Navigation", "Popular", "Trends", "Market", "Analysis"],
      "icon": "📊"
    },
    {
      "name": "Keywords | Expansion | Google Suggestions",
      "url": "https://www.searchsuggest.tips/?keyword=",
      "description": "Get Google search suggestion keywords",
      "tags": ["Keywords", "SEO", "Search", "Google", "Expansion", "Suggestions", "Optimization", "Research", "Market", "Analysis"],
      "icon": "🔑"
    },
    {
      "name": "Keywords | Competition Difficulty",
      "url": "https://ahrefs.com/keyword-difficulty",
      "description": "Analyze keyword competition difficulty",
      "tags": ["Keywords", "SEO", "Competition", "Difficulty", "Analysis", "Research", "Market", "Optimization", "Strategy", "Tools"],
      "icon": "📈"
    },
    {
      "name": "Website Keywords",
      "url": "semrush.com",
      "description": "Comprehensive SEO and keyword analysis tool",
      "tags": ["SEO", "Keywords", "Analysis", "Tools", "Optimization", "Research", "Data", "Monitoring", "Performance", "Strategy"],
      "icon": "🔍"
    },
    {
      "name": "Traffic, Website Keywords",
      "url": "aitdk.com",
      "description": "Analyze website traffic and keywords",
      "tags": ["Traffic", "Keywords", "Analysis", "SEO", "Data", "Research", "Optimization", "Monitoring", "Performance", "Tools"],
      "icon": "📈"
    },
    {
      "name": "Google Search Center | SEO Basics",
      "url": "https://developers.google.com/search/docs/fundamentals/creating-helpful-content?hl=zh-cn",
      "description": "Google SEO basics guide",
      "tags": ["SEO", "Google", "Search", "Basics", "Knowledge", "Guide", "Optimization", "Content", "Strategy", "Tools"],
      "icon": "📚"
    }
  ],
  "templates": [
    {
      "name": "Vercel Website Templates",
      "url": "https://vercel.com/templates",
      "description": "Quickly deployable website templates",
      "tags": ["Templates", "Website", "Deployment", "Vercel", "Development", "Frontend", "Quick", "Responsive", "Design", "Tools"],
      "icon": "🚀"
    },
    {
      "name": "Browser Extension Product | Website Template",
      "url": "https://github.com/mundane799699/xlike-web",
      "description": "Browser extension product website template",
      "tags": ["Extension", "Browser", "Template", "Website", "Development", "Frontend", "Product", "Design", "Tools", "GitHub"],
      "icon": "🔌"
    },
    {
      "name": "SaaS Product | Website Template",
      "url": "https://github.com/JavascriptMick/supanuxt-saas",
      "description": "SaaS product website template",
      "tags": ["SaaS", "Template", "Website", "Development", "Frontend", "Product", "Design", "Tools", "GitHub", "Quick"],
      "icon": "💼"
    }
  ],
  "news": [
    {
      "name": "Projects with $500 Monthly Revenue (Source: HN)",
      "url": "https://www.500mrr.com/",
      "description": "Collection of projects with $500 monthly revenue",
      "tags": ["Revenue", "Projects", "Entrepreneurship", "Income", "Business", "Model", "Case Studies", "Research", "Strategy", "Tools"],
      "icon": "💰"
    },
    {
      "name": "YCombinator",
      "url": "https://news.ycombinator.com/item?id=42373343",
      "description": "YCombinator startup community",
      "tags": ["Startup", "Community", "YCombinator", "Investment", "Accelerator", "Projects", "Case Studies", "Research", "Strategy", "Tools"],
      "icon": "🚀"
    },
    {
      "name": "Reddit Subreddits",
      "url": "https://liberating-doll-b8a.notion.site/Reddit-1a8e8aed91b18021839ecba8b74e530b",
      "description": "Collection of Reddit-related subreddits",
      "tags": ["Reddit", "Community", "Social", "Discovery", "Communication", "Sharing", "Discussion", "Information", "Resources", "Tools"],
      "icon": "💬"
    },
    {
      "name": "Top trending websites | Ahrefs",
      "url": "https://ahrefs.com/websites#trending",
      "description": "Popular trending website analysis",
      "tags": ["Trends", "Websites", "Analysis", "Popular", "Data", "Research", "Monitoring", "Performance", "Strategy", "Tools"],
      "icon": "🔥"
    }
  ],
  "tools": [
    {
      "name": "GSC",
      "url": "https://search.google.com/search-console",
      "description": "Google Search Console, monitor website search performance",
      "tags": ["SEO", "Google", "Search", "Console", "Monitoring", "Analysis", "Performance", "Optimization", "Data", "Tools"],
      "icon": "🔍"
    },
    {
      "name": "GA",
      "url": "https://analytics.google.com/analytics/web/#",
      "description": "Google Analytics, website traffic analysis tool",
      "tags": ["Analytics", "Traffic", "Google", "Data", "Statistics", "Monitoring", "Performance", "Users", "Behavior", "Tools"],
      "icon": "📊"
    },
    {
      "name": "Backlinks",
      "url": "https://ahrefs.com/free-seo-tools",
      "description": "Analyze website backlinks and SEO performance",
      "tags": ["SEO", "Backlinks", "Analysis", "Tools", "Optimization", "Research", "Data", "Monitoring", "Performance", "Strategy"],
      "icon": "🔗"
    },
    {
      "name": "Domain | Search",
      "url": "https://leandomainsearch.com/",
      "description": "Find available domains",
      "tags": ["Domain", "Search", "Registration", "Website", "Availability", "Search", "Tools", "Discovery", "Brand", "Name"],
      "icon": "🌐"
    },
    {
      "name": "Domain | Registration",
      "url": "spaceship.com",
      "description": "Register and manage domains",
      "tags": ["Domain", "Registration", "Management", "Website", "Service", "Hosting", "Brand", "Name", "Tools", "Platform"],
      "icon": "🚀"
    },
    {
      "name": "Website Code | Hosting",
      "url": "https://github.com/WebStackPage/WebStackPage.github.io",
      "description": "Website code hosting and version control",
      "tags": ["Code", "Hosting", "GitHub", "Version Control", "Website", "Development", "Collaboration", "Open Source", "Management", "Tools"],
      "icon": "💻"
    }
  ],
  "buildYourTools": [
    {
      "name": "SaaS Product | App Template",
      "url": "https://github.com/wasp-lang/open-saas/",
      "description": "SaaS application template",
      "tags": ["SaaS", "Application", "Template", "Development", "Frontend", "Product", "Design", "Tools", "GitHub", "Quick"],
      "icon": "📱"
    },
    {
      "name": "Green Screen Video | Website Template",
      "url": "https://github.com/replicate/green-screen-creator",
      "description": "Green screen video production website template",
      "tags": ["Video", "Green Screen", "Template", "Website", "Development", "Frontend", "Product", "Design", "Tools", "GitHub"],
      "icon": "🎬"
    }
  ]
};